// Compact multiline fields grow with their content without changing form data.
const selector='body.cova-site textarea,.cova-application textarea';
function fit(field){
 if(!(field instanceof HTMLTextAreaElement)||!field.matches(selector)||!field.getClientRects().length)return;
 field.style.height='auto';field.style.height=`${Math.max(48,field.scrollHeight+2)}px`;
}
function fitAll(){document.querySelectorAll(selector).forEach(fit);}
document.addEventListener('input',event=>fit(event.target));
document.addEventListener('shopify:section:load',fitAll);
document.addEventListener('cova:form-updated',fitAll);
window.addEventListener('resize',fitAll);
window.addEventListener('pageshow',fitAll);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fitAll,{once:true});else fitAll();
